import { DatePicker } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";

const DateInput = ({ handleRulesOnValueChange, validations, value, placeholder }: any) => {
  const [fieldValue, setFieldValue] = useState(value);
  const { format } = validations;

  useEffect(() => {
    if (value) {
      const parsedValue = moment(value, format); 
      setFieldValue(parsedValue.isValid() ? parsedValue : null);
    } else {
      setFieldValue(null);
    }
  }, [value]);

  return (
    <DatePicker
      style={{ width: "100%" }}
      size="large"
      value={fieldValue}
      format={format}
      onChange={(date) => {
        const formattedDate = date ? date.format(format) : null;
        handleRulesOnValueChange(formattedDate);
        setFieldValue(date);
      }}
      placeholder={placeholder}
    />
  );
};

export default DateInput;
